/// <reference path="../../../../../rcwebmodels/TripDetails.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import moment from 'moment';

import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import * as Exceljs from '../../actions/ExportToExcel.js';
import DateFormat from 'dateformat';
var Excel = Exceljs.default;
var Config: any = require('../../Config.json');

interface EditTripSettingsState {
    SelectedReefers: any[];
    TripGeofencesDetails: server.TripGeofencesDetails;
    refTripDefinition: server.RefTripDefinition[];
    tripGeofencesByTrip: server.TripGeofencesByTrip[];
    DepartureChecked: boolean;
    ArrivalChecked: boolean;
}
var newTripGeofencesDetails: server.TripGeofencesDetails = {
    reeferID: null, TripDefinitionSelectedValue: null, unitMasetrId: null, OriginGeofence: '', DestinationGeofence: '', TripName: '',
    SFrmDate: DateFormat(new Date(moment(new Date(DateFormat(new Date(Date.now()), 'mm/dd/yyyy'))).startOf('day').toString()), 'mm/dd/yyyy HH:MM:ss'),
    SToDate: DateFormat(new Date(moment(new Date(DateFormat(new Date(Date.now()), 'mm/dd/yyyy'))).endOf('day').toString()), 'mm/dd/yyyy HH:MM:ss'), CommandUnits: []
};

var self;

export class EditTrip extends React.Component<any, EditTripSettingsState> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        self = this;
        this.state = { SelectedReefers: [], TripGeofencesDetails: newTripGeofencesDetails, refTripDefinition: [], tripGeofencesByTrip: [], DepartureChecked: false, ArrivalChecked: false };
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/RefTripDefinitionLst')
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.RefTripDefinition[]>)
            .then(data => {
                this.setState({ refTripDefinition: data });
            });
    }
    DepartureCheckedtoggleChange = () => {
        this.setState({
            DepartureChecked: !this.state.DepartureChecked,
        });
    }
    ArrivalCheckedtoggleChange = () => {
        this.setState({
            ArrivalChecked: !this.state.ArrivalChecked,
        });
    }

    public handleOnChange(event: any): void {
        const name = event.target.name;
        const value = event.target.value;
        //this.setState({ [name]: value });
    }
    TripNameOnChange(event: any): void {
        var Value: string = event.currentTarget.value;
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        tripGeofencesDetails.TripName = Value;
        this.setState({ TripGeofencesDetails: tripGeofencesDetails });
    }
    toDateOnChange(date) {
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        tripGeofencesDetails.SToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        this.setState({ TripGeofencesDetails: tripGeofencesDetails });
    }
    fromDateOnChange(date) {
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        tripGeofencesDetails.SFrmDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        this.setState({ TripGeofencesDetails: tripGeofencesDetails });
    }
    handleSubmit(): void {
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        if (!this.state.ArrivalChecked)
            tripGeofencesDetails.SToDate = null;
        if (!this.state.DepartureChecked)
            tripGeofencesDetails.SFrmDate = null;
        if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.TripName == null)) {
            PopupWindow.showErrorMessage("Edit Trip", "Please enter valid Trip Name.");
            return;
        }
        else if ((this.state.TripGeofencesDetails.TripName != null && this.state.TripGeofencesDetails.TripName.trim() == "")) {
            PopupWindow.showErrorMessage("Edit Trip", "Please enter valid Trip Name.");
            return;

        }
        else if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.TripDefinitionSelectedValue == "-1")) {
            PopupWindow.showErrorMessage("Edit Trip", "Please select Trip Definition.");
            return;
        }
        else if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.DestinationGeofence.trim() == "") && (!this.state.ArrivalChecked || !this.state.DepartureChecked)) {
            PopupWindow.showErrorMessage("Create Trip", "A trip should have either Origin and Destination Geofence or Earliest Departure and Arrival or Both.");
            return;
        }
        else if ((this.state.TripGeofencesDetails != null && this.state.TripGeofencesDetails.OriginGeofence.trim() == "") && (!this.state.ArrivalChecked || !this.state.DepartureChecked)) {
            PopupWindow.showErrorMessage("Create Trip", "A trip should have either Origin and Destination Geofence or Earliest Departure and Arrival or Both.");
            return;
        }
        else {
            //tripGeofencesDetails.unitMasetrId = this.state.SelectedReefers[0].UnitMasterID;
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/Trip/EditTripDefDetails';
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(tripGeofencesDetails), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    $('#globalLoader').hide();
                    PopupWindow.showErrorMessage("Edit Trip", data);
                    if (data == "Trip updated successfully.")
                        self.props.refreshTripGrid();
                });
            this.closeModel();
        }
    }
    componentDidMount() {
        var reeferData = this.props.refData;
        if (reeferData != undefined && reeferData != null) {
            var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
            tripGeofencesDetails.TripName = reeferData.TripName;
            tripGeofencesDetails.TripDefinitionSelectedValue = reeferData.TripDefinitionSelectedValue;
            tripGeofencesDetails.SToDate = DateFormat(new Date(reeferData.SToDate), 'mm/dd/yyyy HH:MM');//reeferData.SToDate;
            tripGeofencesDetails.SFrmDate = DateFormat(new Date(reeferData.SFrmDate), 'mm/dd/yyyy HH:MM');//reeferData.SFrmDate;
            tripGeofencesDetails.OriginGeofence = reeferData.OriginGeofence;
            tripGeofencesDetails.DestinationGeofence = reeferData.DestinationGeofence;
            tripGeofencesDetails.reeferID = reeferData.reeferID;
            tripGeofencesDetails.unitMasetrId = reeferData.unitMasetrId;
            tripGeofencesDetails.CommandUnits = reeferData.CommandUnits;
            tripGeofencesDetails.TripId = reeferData.TripId;
            setTimeout(() => {
                this.setState({ TripGeofencesDetails: tripGeofencesDetails });
            }, 20);
            if (reeferData.SToDate != null) {
                this.setState({ ArrivalChecked: true });
            }
            else {
                this.setState({ ArrivalChecked: false });
            }
            if (reeferData.SFrmDate != null) {
                this.setState({ DepartureChecked: true });
            } else {
                this.setState({ DepartureChecked: false });
            }
        }
        // To make the Modal popups draggable.
        Excel.draggableModalPopup(document.getElementById("EditTrip"));
    }
    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.refData;
        if (reeferData != undefined && reeferData != null) {
            var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
            tripGeofencesDetails.TripName = reeferData.TripName;
            tripGeofencesDetails.TripDefinitionSelectedValue = reeferData.TripDefinitionSelectedValue;
            if (reeferData.SToDate != null)
                tripGeofencesDetails.SToDate = reeferData.SToDate;
            else
                tripGeofencesDetails.SToDate = DateFormat(new Date(moment(new Date(DateFormat(new Date(Date.now()), 'mm/dd/yyyy'))).endOf('day').toString()), 'mm/dd/yyyy HH:MM:ss');
            if (reeferData.SFrmDate != null)
                tripGeofencesDetails.SFrmDate = reeferData.SFrmDate;
            else
                tripGeofencesDetails.SFrmDate = DateFormat(new Date(moment(new Date(DateFormat(new Date(Date.now()), 'mm/dd/yyyy'))).startOf('day').toString()), 'mm/dd/yyyy HH:MM:ss');
            tripGeofencesDetails.OriginGeofence = reeferData.OriginGeofence;
            tripGeofencesDetails.DestinationGeofence = reeferData.DestinationGeofence;
            tripGeofencesDetails.reeferID = reeferData.reeferID;
            tripGeofencesDetails.unitMasetrId = reeferData.unitMasetrId;
            tripGeofencesDetails.CommandUnits = reeferData.CommandUnits;
            tripGeofencesDetails.TripId = reeferData.TripId;
            setTimeout(() => {
                this.setState({ TripGeofencesDetails: tripGeofencesDetails });
            }, 20);
            if (reeferData.SToDate != null) {
                this.setState({ ArrivalChecked: true });
            }
            else {
                this.setState({ ArrivalChecked: false });
            }
            if (reeferData.SFrmDate != null) {
                this.setState({ DepartureChecked: true });
            } else {
                this.setState({ DepartureChecked: false });
            }
        }
    }

    GetTripDefination(value: any) {
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Trip/GetGeofencesByTripId', { method: 'POST', body: value, headers: { 'Accept': 'applicatio/json', 'Content-Type': 'application/json' } })
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.TripGeofencesByTrip[]>)
            .then(data => {
                $('#globalLoader').hide();
                this.setState({ tripGeofencesByTrip: data });
                var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
                tripGeofencesDetails.OriginGeofence = this.state.tripGeofencesByTrip[0].SourceGofenceAddress;
                tripGeofencesDetails.DestinationGeofence = this.state.tripGeofencesByTrip[0].DestGofenceAddress;
                tripGeofencesDetails.TripDefinitionSelectedValue = value;
                this.setState({ TripGeofencesDetails: tripGeofencesDetails });
            });
    }
    public handleOnChangeDropDown(event: any): void {
        //this.setState({ [event.target.name]: event.target.value })
        this.GetTripDefination(event.target.value);
    }

    closeModel() {
        $('#EditTrip').hide();
        $('#TripStatus').css('opacity', 1);
        var tripGeofencesDetails: server.TripGeofencesDetails = JSON.parse(JSON.stringify(this.state.TripGeofencesDetails));
        tripGeofencesDetails.TripName = '';
        tripGeofencesDetails.TripDefinitionSelectedValue = '-1';
        tripGeofencesDetails.SToDate = null;
        tripGeofencesDetails.SFrmDate = null;
        tripGeofencesDetails.OriginGeofence = '';
        tripGeofencesDetails.DestinationGeofence = '';
        tripGeofencesDetails.reeferID = '';
        tripGeofencesDetails.unitMasetrId = null;
        tripGeofencesDetails.CommandUnits = [];
        tripGeofencesDetails.TripId = null;
        setTimeout(() => {
            this.setState({ TripGeofencesDetails: tripGeofencesDetails });
        }, 20);
    }

    public render() {
        return (
            <div className='col-md-12 '>
                {this.LoadTripDetailsData(this.state.refTripDefinition)}
            </div>
        );
    }
    LoadTripDetailsData(data: any) {
        const Arrivalhidden = this.state.ArrivalChecked ? 'col-md-5' : 'hidden';
        const Departurehidden = this.state.DepartureChecked ? 'col-md-5' : 'hidden';
        var tripDefinitions = this.state.refTripDefinition;
        var TripDefinationOptions = tripDefinitions.map(function (trip) {
            return (
                <option key={trip.TripDefId} value={trip.TripDefId}>{trip.TripDefNm}</option>
            );
        });
        return (<div>
            <div className="modal" role="dialog" id="EditTrip">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header" id="EditTripHeader">
                            <h5 className="modal-title">Trip Details</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closeModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                         
                        </div>
                        <div className="modal-body">
                            <div className="row mt-2">
                                <div className="col-md-5 text-sm-end  pe-0 ">
                                    <span className='col-form-label'>Reefer ID :</span>
                                </div>
                                <div className="col-md-5">
                                    <div>
                                        {(this.state.TripGeofencesDetails != undefined) ? this.state.TripGeofencesDetails.reeferID : ''}
                                    </div>
                                </div>

                            </div>
                            <div className="row mt-2">
                                <div className="col-md-5 text-sm-end  pe-0 ">
                                    <span className='col-form-label'>Trip Definition :</span>
                                </div>
                                <div className="col-md-5">
                                    <select className="form-select" id="cBoxSeverityStates" name="TripDefinationSelectedValue" value={this.state.TripGeofencesDetails.TripDefinitionSelectedValue}
                                        onChange={e => this.handleOnChangeDropDown(e)} >
                                        <option value="-1">Select TripDefination...</option>
                                        {TripDefinationOptions}
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-5 text-sm-end  pe-0 ">
                                    <span className='col-form-label'>Origin Geofence :</span>
                                </div>
                                <div className="col-md-5">
                                    <span>{this.state.TripGeofencesDetails.OriginGeofence} </span>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-5 text-sm-end  pe-0 ">
                                    <span className='col-form-label'>Destination Geofence :</span>
                                </div>
                                <div className="col-md-5">
                                    <span> {this.state.TripGeofencesDetails.DestinationGeofence} </span>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-5 text-sm-end  pe-0 ">
                                    <span className='col-form-label'>Trip Name :</span>
                                </div>
                                <div className="col-md-5">
                                    <input type="text" className="form-control" id="tripName" value={this.state.TripGeofencesDetails.TripName} name="TripName" onChange={e => this.TripNameOnChange(e)} />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-5 text-sm-end  pe-0 ">
                                    <div> <input type="checkbox" className="departure-checkbox" name="EarliestDep" checked={this.state.DepartureChecked} onChange={this.DepartureCheckedtoggleChange} />Earliest Departure :</div>
                                </div>
                                <div id="dcalc" className={Departurehidden}>
                                   
                                        <div className='input-group date' id='datetimepicker1'>
                                            <div className="input-group date">
                                                <DatePicker
		                                            selected={new Date(this.state.TripGeofencesDetails.SFrmDate)}
		                                            onChange={this.fromDateOnChange.bind(this)}
		                                            timeInputLabel="Time:"
                                                    showYearDropdown
                                                    yearDropdownItemNumber={5}
		                                            dateFormat="MM/dd/yyyy hh:mm aa"
		                                            showTimeInput  
		                                            className="TripDatePicker" 
                                                    id="fDate"                         
	                                            />
                                                
                                            </div>
                                        </div>
                                   
                                </div>
                            </div>
                            <div className="row mt-2 mb-2">
                                <div className="col-md-5 text-sm-end  pe-0 ">
                                    <div className='col-form-label'> <input type="checkbox" className="departure-checkbox" name="Arrival" checked={this.state.ArrivalChecked} onChange={this.ArrivalCheckedtoggleChange} />Arrival :</div>
                                </div>
                                <div className={Arrivalhidden}>                                   
                                        <div className='input-group date' id='datetimepicker2'>
                                            <DatePicker
		                                            selected={new Date(this.state.TripGeofencesDetails.SToDate)}
		                                            onChange={this.toDateOnChange.bind(this)}
		                                            timeInputLabel="Time:"
                                                    showYearDropdown
                                                    yearDropdownItemNumber={5}
		                                            dateFormat="MM/dd/yyyy hh:mm aa"
		                                            showTimeInput  
		                                            className="TripDatePicker" 
                                                    id="tDate"                         
	                                            />
                                        </div>                                                                                    
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={() => this.handleSubmit()} >Save</button>
                            <button type="button" className="btn btn-secondary" onClick={this.closeModel.bind(this)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }

}